// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"221":"mediapipe","894":"diagnostics-screen"}[chunkId] + "." + {"221":"6e16b0ec","894":"a2d59128"}[chunkId] + ".js";
};